export interface SearchParams {
  bodys?: string[];
  colors?: string[];
  conditions?: string[];
  cylinders?: string[];
  doors?: string[];
  drivetrains?: string[];
  fuels?: string[];
  makeModels?: MakeModelsParams[];
  mileage?: string;
  priceMax?: string;
  priceMin?: string;
  titleSs?: string[];
  transmissions?: string[];
  yearMax?: string;
  yearMin?: string;
  page: number;
  rowsPP: number;
  sortIdx: string;
  distance?: string;
  zipCodeObj?: ZipCodeObjectParams;
  error: number;
}

export type StrParams = Pick<SearchParams, 'distance' | 'priceMax' | 'priceMin' | 'yearMax' | 'yearMin'>;

export type StrArrayParams = Pick<
  SearchParams,
  'bodys' | 'colors' | 'conditions' | 'cylinders' | 'doors' | 'drivetrains' | 'fuels' | 'titleSs' | 'transmissions'
>;

export interface MakeModelsParams {
  make: string;
  models: string[];
}

export interface ZipCodeObjectParams {
  code: string;
  city: string;
  state: string;
  latitude: number;
  longitude: number;
}

export const searchParamsInitialState: SearchParams = {
  distance: '10',
  page: 0,
  rowsPP: 10,
  sortIdx: '0',
  error: 0,
};
